import { LineChevronRightSmall } from '@qr-front/icons/line-chevron-right-small'
import { cn } from '@qr-front/ui/utils'
import { Fragment } from 'react'

import { BaseStep } from './BaseStep'
import { TStepProps } from './types'

export const BaseStepper = ({
	stepList,
	className,
}: {
	stepList: Omit<TStepProps, 'index'>[]
	className?: string
}) => {
	return (
		<div
			className={cn(
				'type-body-small flex flex-wrap items-center gap-1 text-grey desktop:gap-4',
				className,
			)}
		>
			{stepList.map(
				({ state, labelMobile, labelDesktop, hideLabel }, index) => (
					<Fragment key={labelDesktop}>
						<BaseStep
							index={index}
							state={state}
							labelMobile={labelMobile}
							labelDesktop={labelDesktop}
							hideLabel={hideLabel}
						/>
						{index < stepList.length - 1 ? (
							<LineChevronRightSmall className="size-4" />
						) : null}
					</Fragment>
				),
			)}
		</div>
	)
}

export default BaseStepper
